import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FISH_CAROUSEL_DIRECTIVES } from './carousel';
import { FishCarouselConfig } from './carousel-config';

export { FishCarousel, FishSlide } from './carousel';
export { FishCarouselConfig } from './carousel-config';


export class FishCarouselModule {
  static forRoot(): ModuleWithProviders { return { ngModule: FishCarouselModule, providers: [FishCarouselConfig] }; }
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{ declarations: FISH_CAROUSEL_DIRECTIVES, exports: FISH_CAROUSEL_DIRECTIVES, imports: [CommonModule] }, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
